import { endOfDay, getTime, startOfDay } from '@cobliteam/utils/date';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory({ basename: '/' });

export const deleteQueryParameters = (paramsToDelete: string[]) => {
  const urlParams = new URLSearchParams(history.location.search);

  paramsToDelete.forEach((paramName) => urlParams.delete(paramName));
  history.replace({ search: `?${urlParams.toString()}` });
};

export const extractQueryDatePeriod = () => {
  const params = new URLSearchParams(history.location.search);
  const selectedDateStr = params.get('date');
  const selectedDate = selectedDateStr ? Number.parseInt(selectedDateStr, 10) : undefined;
  const start = selectedDate && getTime(startOfDay(selectedDate));
  const end = selectedDate && getTime(endOfDay(selectedDate));

  return start && end && { start, end };
};
